import VariableSelection from '@/bo/VariableSelection';

export default {
    selectedYears: [],
    selectedLocations: [],
    selectedLocation: -1,
    currentStep: 'years',
    v: {
        row: VariableSelection.newNotIncluded(),
        column: VariableSelection.newNotIncluded(),
        control1: VariableSelection.newIncluded(),
        control2: VariableSelection.newNotIncluded()
    },
    selectedStatistics: {
        isSet: false,
        sampleSize: false,
        chiSquare: false,
        standardError: false,
        confidenceInterval: false,
        rowPercentage: false,
        columnPercentage: false,
        totalPercentage: false,
        weightedN: false,
        nonResponse: false
    }
}
